export default "__VITE_PUBLIC_ASSET__5a687407__"